import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Categories from './pages/Categories';
import Subcategories from './pages/Subcategories';
import Banners from './pages/Banners';
import Ads from './pages/Ads';
import AdDetail from './pages/AdDetail';
import Reports from './pages/Reports';
import Interests from './pages/Interests';
import Users from './pages/Users';
import UserDetail from './pages/UserDetail';
import SupportTickets from './pages/SupportTickets';
import Settings from './pages/Settings';
import Notifications from './pages/Notifications';
import BlockedUsers from './pages/BlockedUsers';
import Packages from './pages/Packages';

export default function App() {
  return (
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/categories" element={<Categories />} />
                  <Route path="/subcategories" element={<Subcategories />} />
                  <Route path="/banners" element={<Banners />} />
                  <Route path="/packages" element={<Packages />} />
                  <Route path="/ads" element={<Ads />} />
                  <Route path="/ads/:id" element={<AdDetail />} />
                  <Route path="/reports" element={<Reports />} />
                  <Route path="/interests" element={<Interests />} />
                  <Route path="/users" element={<Users />} />
                  <Route path="/users/:id" element={<UserDetail />} />
                  <Route path="/blocked" element={<BlockedUsers />} />
                  <Route path="/support" element={<SupportTickets />} />
                  <Route path="/notifications" element={<Notifications />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
